import { render, staticRenderFns } from "./purinvoicedetailview.vue?vue&type=template&id=4377b8b5&scoped=true&"
import script from "./purinvoicedetailview.vue?vue&type=script&lang=js&"
export * from "./purinvoicedetailview.vue?vue&type=script&lang=js&"
import style0 from "./purinvoicedetailview.vue?vue&type=style&index=0&id=4377b8b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4377b8b5",
  null
  
)

export default component.exports